function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

// (C) Copyright 2017-2018 Hewlett Packard Enterprise Development LP
import { css } from 'styled-components';

var isObject = function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
};

var deepFreeze = function deepFreeze(obj) {
  Object.keys(obj).forEach(function (key) {
    return key && isObject(obj[key]) && Object.freeze(obj[key]);
  });
  return Object.freeze(obj);
};

export var aruba = deepFreeze({
  global: {
    colors: {
      background: '#ffffff',
      brand: '#ED6F00',
      control: {
        dark: '#EF8B27',
        light: '#ED6F00'
      },
      focus: '#FFED00',
      'neutral-1': '#646569',
      'neutral-2': '#004876',
      'neutral-3': '#004876',
      'neutral-4': undefined,
      'accent-1': '#9fd4c9',
      'accent-2': '#d5d848',
      'accent-3': undefined,
      'status-critical': '#dd3000',
      'status-warning': '#f0c954',
      'status-ok': '#008375',
      'status-unknown': '#C3C5C8',
      'status-disabled': '#C3C5C8',
      'dark-1': '#000001',
      'dark-2': '#646569'
    },
    font: {
      family: "'Open Sans', Arial, sans-serif",
      face: undefined
    }
  },
  anchor: {
    color: {
      dark: 'brand',
      light: '#000000'
    }
  },
  button: {
    extend: css(_templateObject(), function (props) {
      return !props.plain && "\n        font-weight: 600;\n        border-radius: 4px;\n      ";
    })
  }
});